import { useMutation } from 'react-query';
import { getPrivateApi } from '../../../../services/api';

export function useQuickBooksExportCreditMemo() {
  return useMutation(async (creditLedgerEntryId: string) => {
    const api = getPrivateApi();

    return api.quickbooksExportCreditMemo({
      quickBooksExportCreditMemoRequest: {
        creditLedgerEntryId,
      },
    });
  });
}
